export default __webpack_public_path__ + "static/listening_background-cfee0e8a28e050f5e0aaee7e384d249b.png";